/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { AppState } from './types'
import Home from './pages/Home/Home'
import Country from './pages/Country/Country'
import Cart from './pages/Cart/Cart'

const Routes = () => {
  const countries = useSelector((state: AppState) => state.countries.countries)
  const filteredCountries = useSelector(
    (state: AppState) => state.countries.filteredCountries
  )

  return (
    <Switch>
      <Route exact path="/" component={Home} />

      <Route
        exact
        path="/countries/:id"
        component={(props: any) => (
          <Country countries={filteredCountries} {...props} />
        )}
      />

      <Route
        exact
        path="/cart"
        component={(props: any) => <Cart countries={countries} {...props} />}
      />
    </Switch>
  )
}

export default Routes
